import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/app-router-context.js");
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/hooks-client-context.js");
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/server-inserted-html.js");
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-no-ssr.js");
import(/* webpackMode: "eager" */ "/app/app/project/[id]/page.module.scss");
import(/* webpackMode: "eager" */ "/app/app/project/[id]/ProjectInfo.tsx");
import(/* webpackMode: "eager" */ "/app/app/project/[id]/ItemList.tsx");
import(/* webpackMode: "eager" */ "/app/app/project/[id]/FilterContext.tsx")